<template>
   <palletinfodashboard>
  <div class="animated fadeIn">

    <b-row>
      <b-col lg="12">
      <!--  <b-breadcrumb :items="breadcrumbs"/>   -->  
       <b-card header-tag="header" footer-tag="footer">
      <div id="overlay" >
             <div class="loader"></div>
           </div>
        <b-row class="mb-4">          
    
            
        
           <b-col sm="12" class="text-right">
             <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button> 
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col>        
        </b-row>
         <div style="float: left;" v-if="this.totalRows > 0">
               <span  class="badge badge-primary">PR</span>&nbsp;&nbsp;&nbsp;Indicates Privilege Rider
             </div>
             <br>

              <b-table  v-if="this.totalRows > 0" style="text-align: left" show-empty stacked="md"  :items="items" :busy="isBusy"    :current-page="currentPage"  :fields="fields"   :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div> 
              <template slot="ridername" slot-scope="row">
                <span class="badge badge-primary" v-if="row.item.privilege_rider== 1">PR</span>&nbsp;&nbsp;&nbsp;
             {{row.item.deliveryagentfirstname}} {{row.item.deliveryagentlastname}}
            </template> 
        
          </b-table>
           <!-- <div class="table-responsive" >
            <table class="table table-striped table-bordered" border="1" v-if="this.totalRows > 0" >
              <thead style="text-align: left" >
                <tr>
                  <th>Rider Name</th>
                  <th>Shipping Id</th>
                  <th>Status</th>
                  <th>Shipment Status</th>
                  <th>Order Flow</th>
                  <th>Pick up Address</th>
                  <th>Shipping Address</th>
                  <th>Shipping City</th>
                  <th>Locality Name</th>
               
                </tr>
              </thead>
              <tbody>
                <tr>
                  
                <td>{{ ridername }}</td>
                <td>{{ shippingid }}</td>
                <td>{{ deliverystatus }}</td>
                <td>{{ shipmentstatus }}</td>
                <td>{{ orderflow }}</td>
                <td>{{ pickuplocationaddress }}</td>
                <td>{{ shipaddress1 }}</td>
                <td>{{ locality_city_name }}</td>
                <td>{{ locality_name }}</td>
                  
                </tr>
              </tbody>
            </table>
          </div> -->
            

                    
                    <b-col md="12" class="my-1 " v-if="this.totalRows > 10" >
            <!-- <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              >
            </b-pagination> -->
<!--               <paginate
   
    :page-count="noofpages"
    :page-range="10"
    :margin-pages="2"
    :click-handler="clickCallback"
    :prev-text="'Prev'"
    :next-text="'Next'"
    :container-class="'pagination'"
    :page-class="'page-item'">
  </paginate> -->
          </b-col> 
      


       
       </b-card>
        
      </b-col>
    </b-row><!--/.row-->

  </div>
   </palletinfodashboard>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
import { EventBus } from "./event-bus.js";
export default {
  mounted() {  
    
      EventBus.$on("clicked-event", pid=> {  
  
  this.displaydata(pid); 
      });  
   }  ,
  data: function() {
    return {
      name: 'codReports',
      data: [],
       records:[],
      items:[],
       fields: [
        { key: 'ridername', label: 'Rider Name', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'shippingid', label: 'Shipping Id', sortable: true, sortDirection: 'desc' },
          { key: 'deliverystatus', label: 'Status', sortable: true, sortDirection: 'desc' },
            { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc' },
          { key: 'orderflow', label: 'Order Flow', sortable: true, sortDirection: 'desc' },
          { key: 'pickuplocationaddress', label: 'Pick up Address', sortable: true, sortDirection: 'desc' },
          { key: 'shipaddress1', label: 'Shipping Address', sortable: true, sortDirection: 'desc' },
          { key: 'locality_city_name', label: 'Shipping City', sortable: true, sortDirection: 'desc' },
          { key: 'locality_name', label: 'Locality Name', sortable: true, sortDirection: 'desc' },

          
          
         ], 
      headinglength:0,
      isBusy: false,
       page:1,
      ridername:'', 
      shippingid:'', 
      deliverystatus:'', 
      shipmentstatus:'', 
       orderflow:'', 
       pickuplocationaddress:'', 
       shipaddress1:'', 
      locality_city_name:'',
      locality_name:'', 
    
     
      bordered: true,
       disabled: '',
      totalRows: 0,
      itemsperpages:5,
      currentPage: 1,
      perPage:  20,
      pageNum:1,
      noofpages:'',
      pageOptions: [5, 10, 15],
      sortBy: true,
      pageNum:1,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      selectDateTo: new Date(),
       selectDateFrom: new Date(),
    }

  },
   computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  created: function () {
    var palletids = JSON.parse(localStorage.getItem("palletid"));
    this.displaydata(palletids)
    
  },

  methods: {
      
        displaydata: function (palletid) {

     
 // alert(palletid);
      
    this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
     // {"pallet_id":"40"}
     

       const info = {
        pallet_id: palletid, 
        hub_id:`${userInfo.pickuplocationmasterid}`,
        
      
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getpalletshipmentlist`,info)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
            //document.getElementById("printbutton").style.display ="block";
             this.items  = result.body.returnvalue;
      //        console.log(result.body.returnvalue[0]);
      // this.ridername=result.body.returnvalue[0].rider_name;
      // this.shippingid=result.body.returnvalue[0].shippingid;
      // this.deliverystatus=result.body.returnvalue[0].deliverystatus; 
      // this.shipmentstatus=result.body.returnvalue[0].shipmentstatus; 
      // this.orderflow=result.body.returnvalue[0].orderflow; 
      // this.pickuplocationaddress=result.body.returnvalue[0].pickuplocationaddress; 
      // this.shipaddress1=result.body.returnvalue[0].shipaddress1; 
      // this.locality_city_name=result.body.returnvalue[0].locality_city_name;
      // this.locality_name=result.body.returnvalue[0].locality_name; 
           
             
             this.totalRows =result.body.returnvalue.length;
             this.isBusy = !this.isBusy;
             // this.customer.pallet_id='';
             
          } else {
           this.isBusy = !this.isBusy
              this.items=[];   
               
            this.totalRows = 0;
            Utils.notify("No Records Found",'error');
            // this.$fire({
            //       text:"No Records Found",
            //       type: "error",
            //       timer: 30000
            //     }); 

           
            
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
   


     clickCallback (pageNum)
       {
      //   alert(" i m in pagination task");
      // alert(pageNum)
      this.showdashboarddetails(pageNum);
    },
//     downloadCSV: function() {
     


    
      
//           var csvObj = {
   
//           pallet_id:49,
            
           
//           };
         
      

//       console.log(csvObj);
     
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
    
//   this.$http.get(`${CONSTANTS.MISREPORT_API_URL}/getpalletshipmentlistcsv`+queryString)
//         .then(result => {
//          console.log(result.url);
//         window.location.href =result.url;
//         });
        
//     },
downloadCSV: function() {
  document.getElementById("overlay").style.display = "block";
      
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

      
      var palletids = JSON.parse(localStorage.getItem("palletid"));
     
     
      
          var csvObj = {
          
           pallet_id:palletids,
           sysusermasterid:`${userInfo.sysusermasterid}`,
           hub_id:`${userInfo.pickuplocationmasterid}`,
           
          };
         
         
      

      console.log(csvObj);
     
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
     
      //var r = Math.random().toString(36).substring(3);

this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getpalletshipmentlistcsv_advanced`,csvObj)


        .then(result => {
         console.log(result.url);
          document.getElementById("overlay").style.display = "none";
        //window.location.href =result.url;
        if(result.body=="success")
         {
         // alert("Please Check Ur Mail For Downlod Link")
           this.$fire({
                  text:"Please Check Ur Mail For Downlod Link",
                  type: "success",
                  timer: 30000
                }); 
       }
       else
       {
        // alert("Can not Download");
        this.$fire({
                  text:"Can not Download",
                  type: "error",
                  timer: 30000
                });
       }
        });
        
    },
// downloadCSV: function() {
      


      
//       var palletids = JSON.parse(localStorage.getItem("palletid"));
     
     
      
//           var csvObj = {
          
//            pallet_id:palletids,
            
           
//           };
         
         
      

//       // console.log(csvObj);
     
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// // console.log(queryString);
     
//       //var r = Math.random().toString(36).substring(3);
// this.$http.get(`${CONSTANTS.MISREPORT_API_URL}/getpalletshipmentlistcsv`+queryString)
//         .then(result => {
//          // console.log(result.url);
//         window.location.href =result.url;
//         });
        
//     },

    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    
    


    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  }
}
</script>

<style type="text/css">
 .totalback
 {
  background: #c8ced3 !important;
   border-right: 1px solid grey !important;
   max-width: 300px !important;
    
  }

  .hidden_header {
    
  display: none;
}
   .pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  transition: background-color .3s;
  border: 1px solid #ddd;
}


.page-item.active {
  background-color: #87CEEB;
    color: white;
}

.pagination a:hover:not(.active) {background-color: #ddd;}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
  

</style>
